<template>
  <div>
    <div>
      <div style="display: flex; justify-content: space-between;">
        <button
          class="navbarBtnTashxis mb-2"
          v-b-modal="
            'modal-shab-creat' + indRegShif
          "
          @click="clickPlus"
        >
          <b-icon icon="plus-lg"></b-icon>
        </button>

        <b-form-group
          label-for="filterTekshiruvlar-input"
          label-cols-sm="1"
          label-align-sm="right"
          label-size="sm"
          class="mb-2 col-8"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filterTekshiruvlar-input"
              v-model="filterShablon"
              type="search"
              :placeholder="$t('Қидирув')"
            ></b-form-input>

            <b-input-group-append>
              <b-button
                :disabled="!filterShablon"
                variant="danger"
                @click="filterShablon = ''"
              >
                {{ $t("Тозалаш") }}
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
      <div>
        <div class="modalOverflow">
          <b-table
            id="bemor-table"
            ref="refShablonTable"
            hover
            sort-icon-left
            striped
            primary-key="id"
            :items="itemsShablon"
            :fields="fieldsShablon"
            :filter="filterShablon"
            :per-page="perPageShablon"
            :current-page="currentPageShablon"
            :filter-included-fields="filterOnShablon"
            :sort-by.sync="sortByShablon"
            :sort-desc.sync="sortDescShablon"
            :sort-direction="sortDirectionShablon"
            @row-clicked="RowClickedShablon($event, indRegShif)"
            stacked="md"
            show-empty
            small
            @filtered="onFilteredShablon"
          >
            <template #cell(№)="data">
              {{ data.index + 1 }}
            </template>
            <template #cell(actions)="row">
              <b-row class="ml-1">
                  <section
                    style="display: flex; justify-content: flex-end; width: 100%; margin-right: 30px"
                  >
                    <div style="display: flex;">
                      <b-button
                        variant="outline-primary"
                        v-b-modal="
                          'modal-shab-creat' + indRegShif
                        "
                        @click="userLink(row.item)"
                        class="pencil"
                      >
                        <b-icon
                          style="width: 15px;"
                          variant="outline-primary"
                          icon="pencil-fill"
                          aria-hidden="true"
                        ></b-icon>
                      </b-button>
                      <div>
                        <b-button
                          class="trash ml-2"
                          style=""
                          variant="outline-danger"
                          @click="trash(row.item.id)"
                        >
                          <b-icon
                            style="width: 15px;"
                            icon="trash-fill"
                            aria-hidden="true"
                          ></b-icon>
                        </b-button>
                      </div>
                    </div>
                  </section>
                </b-row>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <b-modal
      :id="'modal-shab-creat' + indRegShif"
      :title="$t('Шифокор шаблон')"
      size="xl"
      hide-footer
    >
      <div class="md-layout-item md-small-size-100 md-size-100">
        <span class="shirift">
          {{ $t("Номи") }}
        </span>
        <span style="color: red;">*</span>
        <span v-if="errorsShablon != null">
          <span
            style="color: red; font-size: 9px"
            v-if="!errorsShablon.name.required"
            >{{ $t("Ном тўлдирилиши керак") }}</span
          >
          <span
            style="color: red; font-size: 9px"
            v-if="!errorsShablon.name.minLength"
            >{{ $t("Ном камида 4 та белги бўлиши керак") }}</span
          >
        </span>
        <b-input id="Shablon-name" type="text" v-model="ShablonShifokor.name" />
        
        <table class="table table-sm table-bordered mt-3">
      <thead class="BayonotTheadr">
        <tr>
          <th style="width: 30px;">
            <b-button
              variant="success"
              @click="Add()"
              class="retsept-add-btn"
              ><span> <b-icon icon="plus" color="#fff"></b-icon> </span
            ></b-button>
          </th>
          <th style="width: 30%;">
            {{ $t("Дори") }}
          </th>
          <!-- <th>{{ $t("Кун") }}</th>
          <th>{{ $t("Маҳал") }}</th> -->
          <th>{{ $t("Қўшимчалар") }}</th>
          <th style="width: 40px;"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in ShablonShifokor.shablon_recipe" :key="index">
          <td>{{ index + 1 }}</td>
          <td>
            <div class="select-btn-add">
              <v-select
                class="select-btn-retsep"
                :options="itemsDorilar"
                ref="doriselect"
                @search="doriInput"
                :reduce="options => options.id"
                v-model="item.pill_id"
                label="name"
                @input="DoriName(item.pill_id, index)"
                @keydown.native="insertDori($event, indRegShif, index)"
              >
                <template #search="{attributes, events}">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <!-- <button type="button" class="modallist" v-b-modal.modal-skladlist>
                    <b-icon icon="three-dots"></b-icon>
                    </button> -->
                </template>
                <template #selected-option="{ name }">
                  <div style="position:absolute;" class="select-span-text">
                    <label>{{ name }}</label>
                  </div>
                </template>
                <template
                  v-slot:no-options="{
                    search,
                    searching
                  }"
                >
                  <template v-if="searching">
                    <em
                      ><b>{{ search }}</b></em
                    >{{ $t("бўйича маьлумот йўқ") }}
                    <div class="d-flex-center">
                      <b-button
                        class="insertbtn"
                        variant="success"
                        @click="insertDoribtn(search, indRegShif, index)"
                        v-b-modal="'DorilarModal-recipe' + indRegShif + index"
                      >
                        <b-icon icon="plus" color="#fff"></b-icon>
                      </b-button>
                    </div>
                    <b> Insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
                </template>
              </v-select>
              <button
                class="dori-add-btn"
                v-b-modal="'DorilarModal-recipe' + indRegShif + index"
              >
                ...
              </button>

              <b-modal
              :id="'DorilarModal-recipe' + indRegShif + index"
              title="Дори қўшиш"
              hide-footer
            >
              <div class="md-layout-item md-small-size-100 md-size-100">
                <span class="shirift">
                  {{ $t("Дори номи") }}
                </span>
                <span style="color: red;">*</span>
                <span v-if="errorsDori !== null">
                  <span
                    style="color: red; font-size: 9px"
                    v-if="!errorsDori.name.required"
                    >{{ $t("Дори тўлдирилиши керак") }}</span
                  >
                  <span
                    style="color: red; font-size: 9px"
                    v-if="!errorsDori.name.minLength"
                    >{{ $t("Дорида камида 4 та белги бўлиши керак") }}</span
                  >
                </span>
                <b-input
                  id="dorilar-name"
                  style="background: #fff; border: 1px solid #ced4da;"
                  type="text"
                  v-model="DorilarQoshish.name"
                />
              </div>
              <div class="CreateName">
                <b-button
                  class="modalBtn1"
                  size="sm"
                  style="height: 37px;"
                  variant="danger "
                  @click="DoriClose(indRegShif, index)"
                >
                  <b-icon icon="calendar2-x"></b-icon>
                  {{ $t("Бекор қилиш") }}
                </b-button>
                <b-button
                  class="mt-3 ml-2 modalBtn"
                  @click="DoriSaqlash(indRegShif, index)"
                  variant="success"
                >
                  <b-icon icon="calendar2-plus"></b-icon>
                  {{ $t("Сақлаш") }}
                </b-button>
              </div>
            </b-modal>
            </div>
          </td>
          <!-- <td>
            <b-input
              type="text"
              style="background: #fff; border: 1px solid #ced4da;"
              @input="changeRetsept"
              v-model="item.day"
            ></b-input>
          </td>
          <td>
            <b-input
              type="text"
              style="background: #fff; border: 1px solid #ced4da;"
              @input="changeRetsept"
              v-model="item.time"
            ></b-input>
          </td> -->
          <td>
            <b-form-textarea
              style="background: #fff; border: 1px solid #ced4da;"
              v-model="item.comment"
            ></b-form-textarea>
          </td>
          <td>
            <b-button
              style="width: 35px; height: 35px; display: flex; justify-content: center;"
              variant="outline-danger"
              @click="deleteRetsep(index)"
            >
              <b-icon style="width: 17px;" icon="trash"></b-icon>
            </b-button>
          </td>
        </tr>
      </tbody>
    </table>
        
      </div>
      <div class="CreateName">
        <b-button
          class="modalBtn1"
          size="sm"
          style="height: 37px;"
          variant="danger "
          @click="ShifokorShablonClose()"
        >
          <b-icon icon="calendar2-x"></b-icon>
          {{ $t("Бекор қилиш") }}
        </b-button>
        <b-button
          class="mt-3 ml-2 modalBtn"
          @click="ShifokorShablon(indRegShif)"
          variant="success"
        >
          <b-icon icon="calendar2-plus"></b-icon>
          {{ $t("Сақлаш") }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { required, minLength } from "vuelidate/lib/validators";
export default {
  props: ["indRegShif", "itemsShablon", "shabType", "modalIdCom", "itemsDorilar"],
  data() {
    return {
      localUser: JSON.parse(localStorage.getItem("user")),
      fieldsShablon: [
        "№",
        { key: "name", label: this.$t("Номи"), sortable: true },
        { key: "actions", label: "" }
      ],
      // itemsShablon: [],
      totalRowsShablon: 1,
      currentPageShablon: 1,
      perPageShablon: 300,
      sortByShablon: "",
      sortDescShablon: false,
      sortDirectionShablon: "asc",
      filterShablon: null,
      filterOnShablon: ["name"],
      errorsDori: null,
      DorilarQoshish: {
        name: "",
        status: ""
      },
      doriValue: null,
      ShablonShifokor: {
        name: '',
        doctor_id: null,
        shablon_recipe: [{
          doctor_id: JSON.parse(localStorage.getItem("user")).id,
          pill_id: null,
          pill: [],
          time: "",
          day: "",
          comment: "",
          name: ""
        }]
      },
      errorsShablon: null,
    };
  },
  validations: {
    ShablonShifokor: {
      name: {
        required,
        minLength: minLength(4)
      }
    },
    DorilarQoshish: {
      name: {
        required,
        minLength: minLength(4)
      }
    }
  },
  methods: {
    Add() {
      this.ShablonShifokor.shablon_recipe.push({
        doctor_id: this.localUser.id,
        pill_id: null,
        pill: {},
        time: "",
        day: "",
        comment: "",
        name: ""
      });
    },
    clickPlus(){
      this.ShablonShifokor = {
        name: '',
        doctor_id: null,
        shablon_recipe: [{
          doctor_id: JSON.parse(localStorage.getItem("user")).doctor_id,
          pill_id: null,
          pill: [],
          time: "",
          day: "",
          comment: "",
          name: ""
        }]
      }
    },
    ShifokorShablon(indRegShif) {
      let self = this;
      self.ShablonShifokor.doctor_id = self.localUser.id;
      this.$v.$touch();
      if (this.$v.ShablonShifokor.$error == false) {
        let method = ""
        let url = ""
        if(self.ShablonShifokor.id){
          url = "/shablon_recipe/update/" + self.ShablonShifokor.id
          method = "patch"
        } else {
          url = "/shablon_recipe/create"
          method = "post"
        }
        axios({
          method: method,
          url: url,
          data: self.ShablonShifokor
        }).then(res => {
          if (res) {
            self.$emit("ShablonGet", res.data.data);
            self.$bvModal.hide(
              `${"modal-shab-creat" +
                indRegShif
              }`
            );
            self.ShablonShifokor = {
              name: '',
              doctor_id: this.localUser.id,
              shablon_recipe: [{
                doctor_id: this.localUser.id,
                pill_id: null,
                pill: [],
                time: "",
                day: "",
                comment: "",
                name: ""
              }]
            };
          }
        });
      } else {
        this.errorsShablon = this.$v.ShablonShifokor;
      }
    },
    RowClickedShablon($events, indRegShif) {
      this.$emit("RowClickedShab", $events, indRegShif);

      // this.$bvModal.hide(`${"modal-shablon" + indRegShif}`);
    },
    userLink(item){
      this.ShablonShifokor = item
    },
    trash(id){
      let self = this;
      axios({
        method: "delete",
        url: "/shablon_recipe/delete/" + id
      }).then(res => {
        if(res){
          self.$emit("ShablonGet", res.data.data);
        }
      })
    },
    onFilteredShablon(filteredItems) {
      this.totalRowsShablon = filteredItems.length;
      this.currentPageShablon = 1;
    },
    ShifokorShablonClose() {
      this.ShablonShifokor = {
        doctor_id: 0,
        name: "",
        text: "",
        shablon_recipe: [{
          doctor_id: this.localUser.id,
          pill_id: null,
          pill: [],
          time: "",
          day: "",
          comment: "",
          name: ""
        }]
      };
    },
    DoriSaqlash(indSh, index) {
      let self = this;
      this.$v.$touch();
      if (self.$v.DorilarQoshish.$error == false) {
        axios({
          method: "post",
          url: "/pill/create",
          data: self.DorilarQoshish
        }).then(data => {
          if (data) {
            // self.$emit('doriSaqlash', data.data.data, indSh, index)
            self.ShablonShifokor.shablon_recipe[index].pill_id = data.data.data.id;
            self.ShablonShifokor.shablon_recipe[index].pill = data.data.data;
            self.$bvModal.hide(`${"DorilarModal-recipe" + indSh + index}`);
            self.itemsDorilar.push(data.data.data)
            // self.getDorilar();
            self.DorilarQoshish.name = "";
          }
        });
      } else {
        this.errorsDori = this.$v.DorilarQoshish;
      }
    },
    DoriClose(indSh, index) {
      this.DorilarQoshish.name = "";
      this.$bvModal.hide(`${"DorilarModal-recipe" + indSh + index}`);
    },
    doriInput(e) {
      this.doriValue = e;
    },
    insertDori($events, indSh, index) {
      if ($events.keyCode == 45) {
        this.$bvModal.show(`${"DorilarModal-recipe" + indSh + index}`);
        this.DorilarQoshish.name = this.doriValue;
      }
    },
    insertDoribtn(name, indSh, index) {
      this.$bvModal.show(`${"DorilarModal-recipe" + indSh + index}`);
      this.DorilarQoshish.name = name;
    },
    DoriName(id, index) {
      for (let i = 0; i < this.itemsDorilar.length; i++) {
        const element = this.itemsDorilar[i];
        if (element.id == id) {
          this.ShablonShifokor.shablon_recipe[index].name = element.name;
          this.ShablonShifokor.shablon_recipe[index].pill = element
        }
      }
    },
    deleteRetsep(ind) {
      this.ShablonShifokor.shablon_recipe.splice(ind, 1);
    },
  }
};
</script>
